import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';
import { filterActiveSafari } from '../utils/photoUtils';

export const getSafaris = createServerFn()
    .validator((data) => data)
    .handler(async ({ data }) => {
        const response = await api('get', 'safaris', data);
        const resData = response.data || {};
        if (Array.isArray(resData.docs)) {
            resData.docs = resData.docs.map(filterActiveSafari);
        }
        return resData;
    });

